import { html } from 'lit';
import { CustomElement } from 'shared/components/element.js';
import { api } from '@converse/headless';
class ConverseLogo extends CustomElement {
    render() {
        return html`<img src="/static/img/logo.png" alt="پیام‌رسان نور" class="converse-svg-logo">`;
    }
}

api.elements.define('converse-logo', ConverseLogo);
